import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = {
    isTableView: localStorage.getItem('tableView') === 'true' || false,
    isLoading: false
}

const tableViewSlice = createSlice({
    name: 'tableViewSlice',
    initialState,
    reducers: {
        isTableView: (state, action: PayloadAction<boolean>) => {
            localStorage.setItem('tableView', String(action.payload))
            state.isTableView = action.payload
        },
        isLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload
        },
    },
})

export const { actions: tableViewActions } = tableViewSlice
export const { reducer: tableViewReducer } = tableViewSlice
